import { Grid } from '@mui/material';
import React, { useState } from 'react';
import ImageLoader from './components/ImageLoader';
import { QUARTERLY_GOAL_IMG_URL } from './constants';

const containerStyles = { width: '90%', display: 'flex', justifyContent: 'center' };

export default function QuarterGoalPage() {
  const [isLoading, setIsLoading] = useState(true);

  const handleImageLoad = () => {
    setIsLoading(false);
  };
  return (
    <Grid Container>
      <ImageLoader open={isLoading} />

      <Grid item xs={12} style={containerStyles}>
        <img
          src={QUARTERLY_GOAL_IMG_URL}
          onLoad={handleImageLoad}
          alt="Quarterly Goal"
          style={{
            display: isLoading ? 'none' : 'block',
            border: '1px solid black',
            maxWidth: '95%',
            width: '750px',
          }}
        />
      </Grid>
    </Grid>
  );
}
